
const initialState = {
    baseJson: { count: "0" },
}
/**
 * 
 * 2-2 redux
 * 
 * reducer
 * 
 * @param state 
 * @param action 
 */
function reducer(state: any = initialState, action: any) {
    switch (action.type) {
        case "ajax_get_post":

            console.log("datas is " , action.volume);

            return Object.assign({}, state, {
                "baseJson": action.volume,
            });
            break;

        case "test":
            return { ...state, "test": action.volume.test }
            break;



        default:
            return state;
            break;
    }
}

export default reducer;
